import React, { useState, useCallback, useEffect } from 'react'
import MaterialTable from '../../../../lib/MaterialTable'
import { data, columns } from './tableData'
import Container from './styles'
import {useDispatch, useSelector} from 'react-redux'
import {AdminOrders} from '../../../../store/actions'
import {useLocation} from 'react-router-dom'

const RecentOrderPallet = ({search}) => {
  const [showDisplay, setState] = useState(false)

  const {pathname}= useLocation()

  const clickHandler = useCallback(
    (e) => {
      if (showDisplay && !e.target.classList.contains('btn--showMore')) {
        setState(false)
      }
    },
    [showDisplay]
  )


  const dispatch = useDispatch()
  const {Orders} = useSelector((s) => s.AdminData)
  
  // Safely access orders data with fallback
  const ordersData = Orders?.order || Orders?.data || []
  
  const filterData = ordersData.filter((result)=>{
    if(result.id && result.id.includes(search)){
      return result
    }
    return false
  })

  useEffect(()=>{
    dispatch(AdminOrders(1, 10))
  },[dispatch, pathname])

  useEffect(() => {
    document.addEventListener('click', clickHandler)
    return () => {
      document.removeEventListener('click', clickHandler)
    }
  }, [clickHandler])

  return (
    <Container>
      <MaterialTable
       options={{
        filtering: true
      }}
        columns={columns({
          handleDisplayMenu: (id) => setState(id),
          showDisplay,
        })}
        data={filterData}
        page = {Orders?.page || 0}
      />
    </Container>
  )
}

export default RecentOrderPallet
